import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';
import { get, post } from './_defaults/fetch.js';
import { cookies } from './_defaults/cookies';

export async function getPublicToken() {
    try {
        const response = await post("/auth/public");
        const data = jwtDecode(response.token);
        const expires = differenceInCalendarDays(new Date(), new Date(data.exp));
        Cookies.set(cookies.public, response.token, { expires });
        return response;
    } catch(error) {
        console.log("ERROR login");
        console.log(error);
        throw error;
    }
}

export async function login({data}) {

    try {
        const response = await post("/auth/oauth/credentials", data);

        if(response.status === 404) {
            throw response;
        }

        return decodeToken(response?.data);
    } catch(error) {
        console.log("ERROR login");
        throw error;
    }
}

export async function userExists({data}) {
    
    try {
        const response = await get("/auth/exists", {params: data});

        return decodeToken(response?.data);
    } catch(error) {
        console.log("ERROR userExists");
        throw error;
    }
}

export async function signup({data}) {

    try {
        const response = await post("/auth/oauth/credentials", data);

        return decodeToken(response?.data);

    } catch(error) {
        console.log("ERROR signup");
        throw error;
    }
}

export function logout() {

    Cookies.remove(cookies.authorization)
    Cookies.remove(cookies.refresh)
    Cookies.remove(cookies.user)

    return true
}

export async function refreshUser() {

    try {

        let refreshToken = Cookies.get(cookies.refresh);
        let userId = Cookies.get(cookies.user);

        if(!refreshToken || !userId) {
            return;
        }

        const response = await post("/auth/refresh", {_id: userId, refreshToken});

        return decodeToken(response?.data);
    } catch(error) {
        console.log("ERROR refreshUser");
        logout();
        throw error;
    }
}

export async function askUserPassword({data}) {
    const response = await post("/auth/password/ask", data);

    if (response.data) {
        return response.data;
    }

    return response;
}

export async function resetUserPassword({data}) {
    const response = await post("/auth/password/reset", data);

    if (response.data) {
        return response.data;
    }

    return response;
}

function decodeToken({token, ...response} = {}) {

    if (token) {

        const user = jwtDecode(token);
        const expires = differenceInCalendarDays(new Date(user.exp * 1000), new Date());
        Cookies.set(cookies.authorization, token, { expires });
        Cookies.set(cookies.user, user.id, { expires });

        return {
            ...user,
            isNew: response.isNew
        }
    }

    return response
}